import PropTypes from 'prop-types';
import {
    ROLE_ADMINISTRATOR,
    ROLE_OPERATOR,
    ROLE_BUYER,
} from '../../services/readRedesignAccount';

export const headerTranslationKeys = {
    searchTitle: PropTypes.string.isRequired,
    openSearch: PropTypes.string.isRequired,
    closeSearch: PropTypes.string.isRequired,
    openMenu: PropTypes.string.isRequired,
    closeMenu: PropTypes.string.isRequired,
    myTickets: PropTypes.string.isRequired,
    manageEvents: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    logoAlt: PropTypes.string.isRequired,
    profileLabel: PropTypes.string.isRequired,
    connectedOperatorMessage: PropTypes.string.isRequired,
    connectedOperatorMessageOperator: PropTypes.string.isRequired,
    connectedOperatorCheckoutImportant: PropTypes.string.isRequired,
    connectedOperatorCheckoutPaymentSkipped: PropTypes.string.isRequired,
    accountLogout: PropTypes.string.isRequired,
    stopImpersonating: PropTypes.string.isRequired,
    accountSignedInAsAdministrator: PropTypes.string.isRequired,
    accountSignedInAsOperator: PropTypes.string.isRequired,
    accountSignedInAsBuyer: PropTypes.string.isRequired,
    userSettings: PropTypes.string.isRequired,
};

export const headerTranslationsShape = PropTypes.shape(headerTranslationKeys);

export const accountShape = PropTypes.shape({
    role: PropTypes.oneOf([ROLE_ADMINISTRATOR, ROLE_OPERATOR, ROLE_BUYER]).isRequired,
    logoutUrl: PropTypes.string.isRequired,
    settingsUrl: PropTypes.string,
    fullName: PropTypes.string,
    email: PropTypes.string,
    stopImpersonatingUrl: PropTypes.string,
});
